import { useEffect, useRef, useState } from "react";
import gameConfig from "./config";
import GameService from "../../../api/services/GameService";
import { useNavigate, useParams } from "react-router-dom";
import { Game } from "phaser";
import { isMobile } from "../../../utils/_helper";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import EventTracker from "../../../utils/EventTracker";

const launchFullScreen = (element) => {
  try {
    if (element) {
      if (element.requestFullScreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen();
      }
      // eslint-disable-next-line no-restricted-globals
      if (screen && screen.orientation) screen.orientation.lock("landscape");
    }
  } catch (error) {
    console.log(error);
  }
};

const GAME = {},
  exit = () => {
    let gameConfig = GAME.instance ? GAME.instance : null;
    if (gameConfig) {
      let mainScene = gameConfig.scene.scenes[0];
      if (mainScene) {
        mainScene.bgm.pause();
        gameConfig.destroy();
        delete GAME.instance;
      }
    }
  };

const PhaserComponent = () => {
  const ref = useRef(null),
    navigate = useNavigate(),
    params = useParams(),
    mobile = isMobile(),
    { width, height } = useWindowDimensions(),
    [session, setSession] = useState(null),
    [loading, setLoading] = useState(true),
    [game, setGame] = useState();
  useEffect(() => {
    if (mobile && loading) {
      launchFullScreen(document.getElementById("phaser"));
      setLoading(false);
    }
  }, [mobile, loading]);
  useEffect(() => {
    if (!loading) return;
    const getGameSession = async () => {
      if (!session) {
        const { success, data } = await GameService.getGameSession(params.slug);
        if (success) setSession(data);
      }
    };
    getGameSession(params.slug);
  }, [loading, params.slug, session]);
  useEffect(() => {
    if (!loading && !game && session && width > height) {
      EventTracker.instance.trackEvent("Open Game", {
        "Game-Name": session.game.slug,
        "User-Type":
          session.recommendations.length > 0 ? "Old User" : "New User",
      });
      const newGame = new Game({
        ...gameConfig(width, height, mobile),
        parent: ref.current,
      });
      GAME.instance = newGame;
      newGame.scene.start("MAIN", {
        step: 0,
        data: session,
        sheet:
          session && session.response && session.response.sheet
            ? session.response.sheet
            : null,
        list: session.recommendations || [],
        navigate,
        exit: () => {
          delete GAME.instance;
          newGame.destroy();
          // navigate(-1);
          window.flutter_inappwebview.callHandler(
            "gameCloseEvent_closeGame",
            "*"
          );
        },
      });
      setGame(newGame);
    }
  }, [session, height, game, loading, width, mobile, navigate]);
  return (
    <div
      id="phaser"
      className={!mobile ? "py-10" : ""}
      style={{ fontFamily: "AvenirNext-Regular" }}
    >
      <div ref={ref} />
    </div>
  );
};

export default PhaserComponent;
export { exit };
